import { render } from "./DataAdapterTools.vue?vue&type=template&id=4826a605"
import script from "./DataAdapterTools.vue?vue&type=script&lang=js"
export * from "./DataAdapterTools.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/views/project/data-adapters/DataAdapterTools.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4826a605"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4826a605', __exports__)) {
    api.reload('4826a605', __exports__)
  }
  
  module.hot.accept("./DataAdapterTools.vue?vue&type=template&id=4826a605", () => {
    api.rerender('4826a605', render)
  })

}


export default __exports__